import { getQRCodeIata } from "../services/patient";
import { getAssignedToMeFolderHelp } from "../services/folderHelp";
import { reloadScans } from "../services/prescription";
import { wsConnect, wsConnected, wsDisconnected, wsNewMessage } from "services/websocket";
import { toast } from "react-toastify";

const socketMiddleware = () => {
	let socket = null;
	let msgs = [];

	const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

	const onOpen = (store, msgAuth) => (event) => {
		store.dispatch(wsConnected(process.env.REACT_APP_WS_URL));
		store.dispatch(wsNewMessage(msgAuth));
	};

	const onClose = (store) => async (event) => {
		if (event.target.readyState === 3) {
			store.dispatch(wsDisconnected());
			await sleep(10000);
			store.dispatch(wsConnect());
		} else {
			store.dispatch(wsConnect());
		}
	};

	const onError = (store) => async (error) => {
		if (error.target.readyState === 3) store.dispatch(wsDisconnected());
		else {
			await sleep(10000);
			store.dispatch(wsConnect());
		}
	};

	const onMessage = (store) => (event) => {
		const payload = JSON.parse(event.data);
		switch (payload.type) {
			case "iata":
				store.dispatch(getQRCodeIata(payload.patientId));
				break;
			case "telesec":
				store.dispatch(getAssignedToMeFolderHelp());
				break;
			case "scans":
				toast.warn("Un document scanné a été reçu. ");
				store.dispatch(reloadScans(payload.prescriptionId, payload.barcode));
				break;
			default:
				break;
		}
	};

	// the middleware part of this function
	return (store) => (next) => (action) => {
		switch (action.type) {
			case "WS_CONNECTED":
				return socket !== null && socket.url === action.host && socket.readyState === 1;
			case "WS_DISCONNECTED":
				return socket === null;
			case "WS_CONNECT":
				if (socket !== null && socket.url === action.host) {
					socket.close();
				}

				// connect to the remote host
				try {
					socket = new WebSocket(action.host);
				} catch (e) {
					console.log("Une erreur est survenue à la connexion du websocket :", e);
				}
				var msgAuth = {
					type: "authenticate",
					payload: {
						token: store.getState().user.session.refreshToken ?? store.getState().user.session.token,
						refresh: !!store.getState().user.session.refreshToken,
					},
				};

				// websocket handlers
				socket.onmessage = onMessage(store);
				socket.onclose = onClose(store);
				socket.onopen = onOpen(store, msgAuth);
				socket.onerror = onError(store);
				break;
			case "WS_DISCONNECT":
				if (socket !== null) {
					socket.close();
				}
				socket = null;
				break;
			case "NEW_MESSAGE":
				if (socket.readyState === 1) {
					socket.send(JSON.stringify(action.msg));
				}
				break;
			default:
				return next(action);
		}
	};
};

export default socketMiddleware();
